import * as React from "react";
import { forwardRef } from "react";
const SvgIconEmail = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H4Zm2.64 4.232a1 1 0 0 0-1.28 1.536l4.72 3.933a3 3 0 0 0 3.84 0l4.72-3.933a1 1 0 1 0-1.28-1.536l-4.72 3.933a1 1 0 0 1-1.28 0L6.64 7.232Z", fill: "#777E91", opacity: 0.6 }));
const ForwardRef = forwardRef(SvgIconEmail);
export default ForwardRef;
